import ScopeConstants from "constants/ScopeConstants"
import { FormActionReducer } from "@gman/gman-redux"

export const ReportUnpaidInvoicesReducer = (
  state = {
    ...FormActionReducer.defaultPageState(),
    ...FormActionReducer.defaultSearchOptions(),
    reportName: "Unpaid Invoices Report",
    reportDescription: "An export of unpaid invoices, in CSV format."
  },
  action) => {

  if (action.scope === ScopeConstants.REPORT_INVOICES_UNPAID) {
    return FormActionReducer.reduce(action, state)
  }

  return state
}